/* Sturdy Cycles: spec selector on the frame-kit page (2026_REBRAND).
   20 Oct 2026: build kit add-on. 21 Oct 2026: Drivetrain choice; "Your spec" summary and job-sheet cart lines.
   22 Oct 2026: "Your spec" no longer says "frame kit" twice when the product title already ends in it.
   23 Oct 2026: optional Titanium crankset tick box (only when the kit has a "Titanium crankset" option). Its price and
   wording follow the drivetrain: 2X keeps the groupset's chainrings, 1X (or no drivetrain choice) adds the titanium 1X chainring.
   - "Your spec" lists the choices in plain words and updates as they change.
   - The frame kit line always carries the spec as line item properties (Build ref, Size, Stack, Build kit, Finish, Fit details),
     kept as hidden properties[...] inputs in the product form, so "Buy it now" carries them too.
   - When "Add the … build kit" is ticked, the Add to cart button adds the frame and the kit together: just before the theme reads
     the form, the frame's id/quantity/properties are swapped for items[] entries (frame, then kit, both with the same Build ref),
     then put back straight after. The kit variant is picked from the Drivetrain choice and the Titanium upgrade and
     Titanium crankset ticks.
   - A new Build ref is made after every add to cart, so two bikes never share one. */
(function () {
  var FINISH = 'Standard, or a custom theme or bespoke finish agreed after ordering';
  var FIT = 'Collected by email after ordering';
  var CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var CR_2X = 'Our machined titanium crank arms, with the groupset’s 2X chainrings.';
  var CR_1X = 'Our machined titanium crankset and titanium 1X chainring.';
  function newRef(prefix) {
    var s = '';
    for (var i = 0; i < 5; i++) s += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
    return (prefix || 'STU') + '-' + s;
  }
  function setup(box) {
    var comp = box.closest('[data-js-product-component]') || document;
    var add = box.querySelector('[data-sbk-add]');
    var ti = box.querySelector('[data-sbk-ti]');
    var tiwrap = box.querySelector('[data-sbk-tiwrap]');
    var cr = box.querySelector('[data-sbk-cr]');
    var crwrap = box.querySelector('[data-sbk-crwrap]');
    var crprice = box.querySelector('[data-sbk-crprice]');
    var crnote = box.querySelector('[data-sbk-crnote]');
    var dtwrap = box.querySelector('[data-sbk-dtwrap]');
    var specEl = box.querySelector('[data-sbk-spec]');
    var opts = {}, kits = [], crinfo = {};
    try { opts = JSON.parse(box.querySelector('[data-sbk-variants]').textContent); } catch (e) {}
    try { kits = JSON.parse((box.querySelector('[data-sbk-kits]') || {}).textContent || '[]'); } catch (e) {}
    try { crinfo = JSON.parse((box.querySelector('[data-sbk-crinfo]') || {}).textContent || '{}'); } catch (e) {}
    var ref = newRef(box.dataset.refPrefix);
    function form() { return comp.querySelector('product-form form') || comp.querySelector('form[data-type="add-to-cart-form"]'); }
    function quick(on) {
      comp.querySelectorAll('.shopify-payment-button').forEach(function (el) { el.hidden = on; el.style.display = on ? 'none' : ''; });
    }
    function dt() { var el = box.querySelector('[data-sbk-dt]:checked'); return el ? el.value : ''; }
    function wantKit() { return !!(add && add.checked); }
    function wantTi() { return !!(wantKit() && ti && ti.checked); }
    function crOffered() { return !!(cr && Object.prototype.hasOwnProperty.call(crinfo, dt())); }
    function wantCr() { return !!(wantKit() && crOffered() && cr.checked); }
    function crWords() { return dt() === '2X' ? 'titanium cranks' : 'titanium crankset and chainring'; }
    function kitId() {
      for (var i = 0; i < kits.length; i++) {
        if ((kits[i].dt || '') === dt() && !!kits[i].ti === wantTi() && !!kits[i].cr === wantCr()) return kits[i].id;
      }
      return null;
    }
    function frameOpts() {
      var f = form(); var idIn = f && f.querySelector('input[name="id"]');
      return (idIn && opts[idIn.value]) || {};
    }
    function frameName() {
      var o = frameOpts(), v = [];
      for (var k in o) if (o[k] && o[k] !== 'Default Title') v.push(o[k]);
      return box.dataset.frame + (v.length ? ' – ' + v.join(' / ') : '');
    }
    function kitSummary() {
      if (!wantKit()) return 'No (frame kit only)';
      var parts = [];
      if (dt()) parts.push(dt());
      parts.push(wantTi() ? 'titanium upgrade' : 'standard parts');
      if (wantCr()) parts.push(crWords());
      return 'Yes – ' + parts.join(', ');
    }
    function frameProps() {
      var p = [['Build ref', ref]], o = frameOpts();
      for (var k in o) if (o[k] && o[k] !== 'Default Title') p.push([k === 'Stack' ? 'Stack' : k, o[k]]);
      if (add) p.push(['Build kit', kitSummary()]);
      p.push(['Finish', FINISH]);
      p.push(['Fit details', FIT]);
      return p;
    }
    function kitProps() {
      var p = [['Build ref', ref], ['For', frameName()]];
      if (dt()) p.push(['Drivetrain', dt()]);
      p.push(['Titanium upgrade', wantTi() ? 'Yes – brake levers, jockey wheels and bar end plugs' : 'No']);
      if (cr) p.push(['Titanium crankset', wantCr() ? 'Yes – ' + crWords() : 'No']);
      return p;
    }
    /* hidden properties[...] inputs kept in the form for the frame line */
    var propsHolder = document.createElement('div');
    propsHolder.hidden = true;
    propsHolder.setAttribute('data-sbk-props', '');
    function syncProps() {
      var f = form();
      if (!f) return;
      if (propsHolder.parentNode !== f) f.appendChild(propsHolder);
      propsHolder.innerHTML = '';
      frameProps().forEach(function (p) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + p[0] + ']'; i.value = p[1]; propsHolder.appendChild(i);
      });
    }
    function renderSpec() {
      if (!specEl) return;
      var fname = /frame kit$/i.test(box.dataset.frame) ? box.dataset.frame : box.dataset.frame + ' frame kit';
      var rows = [['Frame', fname]], o = frameOpts();
      for (var k in o) if (o[k] && o[k] !== 'Default Title') rows.push([k, o[k]]);
      if (add) {
        rows.push(['Build kit', wantKit() ? (dt() ? dt() + ' build kit' : 'Yes') : 'No']);
        if (wantKit() && ti) rows.push(['Titanium upgrade', wantTi() ? 'Yes' : 'No']);
        if (wantKit() && crOffered()) rows.push(['Titanium crankset', wantCr() ? 'Yes' : 'No']);
      }
      rows.push(['Finish', 'Agreed after ordering']);
      rows.push(['Fit', 'Crank, stem, bar width and saddle height collected after ordering']);
      specEl.innerHTML = '';
      rows.forEach(function (r) {
        var d1 = document.createElement('dt'); d1.textContent = r[0];
        var d2 = document.createElement('dd'); d2.textContent = r[1];
        specEl.appendChild(d1); specEl.appendChild(d2);
      });
    }
    function update() {
      if (add) {
        if (tiwrap) tiwrap.hidden = !add.checked;
        if (dtwrap) dtwrap.hidden = !add.checked;
        if (!add.checked && ti) ti.checked = false;
        if (crwrap) {
          crwrap.hidden = !add.checked || !crOffered();
          if (crwrap.hidden) cr.checked = false;
          if (crOffered()) {
            if (crprice) crprice.textContent = crinfo[dt()];
            if (crnote) crnote.textContent = dt() === '2X' ? CR_2X : CR_1X;
          }
        }
        quick(add.checked);
      }
      syncProps();
      renderSpec();
    }
    function later() { update(); setTimeout(update, 60); setTimeout(update, 400); }
    comp.addEventListener('change', later);
    comp.addEventListener('click', function (e) { if (e.target.closest('product-variants, variant-selects, [data-js-product-variants]')) later(); });
    comp.addEventListener('VARIANT_CHANGE', later);
    update();
    document.addEventListener('submit', function (e) {
      var f = form();
      if (!f || e.target !== f) return;
      update();
      var idIn = f.querySelector('input[name="id"]');
      var kit = wantKit() ? kitId() : null;
      if (idIn && kit) {
        var qtyIn = f.querySelector('input[name="quantity"]');
        var q = qtyIn ? Math.max(1, parseInt(qtyIn.value, 10) || 1) : 1;
        var holder = document.createElement('div');
        holder.hidden = true;
        var fields = [['items[][id]', idIn.value], ['items[][quantity]', q]];
        frameProps().forEach(function (p) { fields.push(['items[][properties][' + p[0] + ']', p[1]]); });
        fields.push(['items[][id]', kit], ['items[][quantity]', q]);
        kitProps().forEach(function (p) { fields.push(['items[][properties][' + p[0] + ']', p[1]]); });
        fields.forEach(function (p) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; holder.appendChild(i);
        });
        f.appendChild(holder);
        var off = [idIn].concat(qtyIn ? [qtyIn] : [], [].slice.call(propsHolder.querySelectorAll('input')));
        off.forEach(function (el) { el.disabled = true; });
        setTimeout(function () {
          off.forEach(function (el) { el.disabled = false; });
          holder.remove();
        }, 0);
      }
      /* a fresh reference for the next bike, once the theme has read this one */
      setTimeout(function () { ref = newRef(box.dataset.refPrefix); syncProps(); }, 0);
    }, true);
  }
  function init() { document.querySelectorAll('[data-sbk]').forEach(function (b) { if (!b._sbk) { b._sbk = 1; setup(b); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
